/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CISType {
    U_VISION = 'uVision',
    THIRD_PARTY = 'ThirdParty',
}